"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Popup", {
  enumerable: true,
  get: function get() {
    return _Popup.default;
  }
});
exports.default = void 0;

var _Tooltip = _interopRequireDefault(require("./Tooltip"));

var _Popup = _interopRequireDefault(require("./Popup"));

var _default = _Tooltip.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-tooltip/lib/index.js
// module id = 419
// module chunks = 0